import { AppDetail } from './interfaces';

export function groupApplications<App extends AppDetail>(applications: App[]) {
  return {
    apps: applications.filter(
      (app) =>
        app.internalApplicationType === 'Portal Application' ||
        app.internalApplicationType === 'External Application'
    ),
    scorecards: applications.filter(
      (app) => app.internalApplicationType === 'Scorecard'
    ),
  };
}

export function getVisualCharacterCount(word: string) {
  const wideChars = ['W', 'M'];
  return word
    .split('')
    .reduce(
      (acc, current) => (wideChars.includes(current) ? acc + 1.5 : acc + 1),
      0
    );
}
